import {Column} from 'react-table'
import {PendingIssues} from '../../core/_models'
import {PendingIssuesInfoCell} from './PendingIssuesInfoCell'
import {PendingIssuesCustomHeader} from './PendingIssuesCustomHeader'
import {PendingIssuesTableCell} from './PendingIssuesTableCell'

const pendingIssuesColumns: ReadonlyArray<Column<PendingIssues>> = [
  {
    Header: (props) => (
      <PendingIssuesCustomHeader
        tableProps={props}
        title='ACCESS.PENDING_ISSUES.EMPLOYEE'
        className='min-w-125px'
      />
    ),
    accessor: 'employee_name',
  },
  {
    Header: (props) => (
      <PendingIssuesCustomHeader
        tableProps={props}
        title='ACCESS.PENDING_ISSUES.ACTIVITY'
        className='min-w-125px'
      />
    ),
    id: 'activity_info',
    Cell: ({...props}) => <PendingIssuesInfoCell pending_issues={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <PendingIssuesCustomHeader
        tableProps={props}
        title='ACCESS.PENDING_ISSUES.TYPE'
        className='min-w-125px'
      />
    ),
    id: 'table',
    Cell: ({...props}) => (
      <PendingIssuesTableCell pending_issues_table={props.data[props.row.index].table} />
    ),
  },
  {
    Header: (props) => (
      <PendingIssuesCustomHeader
        tableProps={props}
        title='ACCESS.PENDING_ISSUES.CONTROL_MEASURE_NAME'
        className='min-w-125px'
      />
    ),
    accessor: 'controlMeasure_name',
  },
  {
    Header: (props) => (
      <PendingIssuesCustomHeader
        tableProps={props}
        title='ACCESS.PENDING_ISSUES.REQUESTED_BY_NAME'
        className='min-w-125px'
      />
    ),
    accessor: 'requestedBy_user_fullName',
  },
]

export {pendingIssuesColumns}
